import Vue from "vue";
import { tenantFlag } from "@/services/tenantConfigService";

/**
 * The `appConfig.json` key that rolls out the welcome modal, the guided tour and their two
 * Configuration page settings, so they can reach internal staff before customers.
 *
 * The string "true" turns them on, as for `VITE_APP_CENTRAL_FILL_ENABLED`; a JSON `true` does too,
 * because it is the obvious thing to type and would otherwise leave a tenant silently dark. Anything
 * else -- including a tenant file that never mentions the key -- keeps them off, so the features
 * reach a tenant only when its own file says so. The tenant's Disable toggles still apply on top.
 */
export const ONBOARDING_ROLLOUT_KEY = "VITE_APP_ONBOARDING_ENABLED";

/**
 * Whether this deployment has the onboarding features at all. `$config` is set on the prototype
 * before the app mounts and never changes afterwards, so there is nothing to be reactive about.
 */
export function isOnboardingRolledOut(): boolean {
    const config = Vue.prototype.$config as Record<string, unknown> | undefined;
    const value = config?.[ONBOARDING_ROLLOUT_KEY];
    return value === "true" || value === true;
}

/** The welcome modal is off: not rolled out here, or the tenant has switched it off. */
export function isWelcomeDisabled(): boolean {
    return !isOnboardingRolledOut() || tenantFlag("disableWelcomeModal");
}

/** The guided tour is off: not rolled out here, or the tenant has switched it off. */
export function isGuidedTourDisabled(): boolean {
    return !isOnboardingRolledOut() || tenantFlag("disableGuidedTour");
}
